import { useNavigate } from "react-router-dom";

import EmptyTable from "components/EmptyTable";
import { Table, Heading, Row, FieldValue, FieldName } from "components/LayoutParts";
import Pagination from "components/Pagination";

import { PIT_PORT_OWNER_ENTITY_TYPE_LABEL } from "../constants";

const ownerEntityTableColumn = [
  {
    label: "貸主名",
    sortKey: "name",
    flex: 13,
  },
  {
    label: "住所",
    sortKey: "address",
    flex: 19,
  },
  {
    label: "電話番号",
    sortKey: "phoneNumber",
    flex: 19,
  },
  {
    label: "メールアドレス",
    sortKey: "email",
    flex: 19,
  },
  {
    label: "種類",
    sortKey: "type",
    flex: 12,
  },
  {
    label: "利益配分率",
    sortKey: "profitShareRate",
    flex: 12,
  },
] as const;

const DataTable = ({
  userList,
  totalPages,
  pageIndex,
  setPageIndex,
}: {
  userList: OwnerEntity[];
  totalPages: number;
  pageIndex: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
  searchKeyword: string;
}) => {
  const navigate = useNavigate();
  const onClickRow = (ownerEntityId: string) => navigate(`/pit_port/owner-entities/${ownerEntityId}`);
  const onClickAddOwnerEntity = () => navigate(`/pit_port/owner-entities/create`);

  return (
    <>
      <Table>
        <Heading>
          {ownerEntityTableColumn.map((column, i) => (
            <FieldName key={column.label} flex={column.flex} lastColumn={i === ownerEntityTableColumn.length - 1}>
              {column.label}
            </FieldName>
          ))}
        </Heading>
        {userList.length > 0 ? (
          userList.map((user) => (
            <Row key={user.id} onClick={() => onClickRow(user.id)}>
              <FieldValue flex={ownerEntityTableColumn[0].flex}>{user.name}</FieldValue>
              <FieldValue flex={ownerEntityTableColumn[1].flex}>{user.address}</FieldValue>
              <FieldValue flex={ownerEntityTableColumn[2].flex}>{user.tel}</FieldValue>
              <FieldValue flex={ownerEntityTableColumn[3].flex}>{user.email}</FieldValue>
              <FieldValue flex={ownerEntityTableColumn[4].flex}>
                {PIT_PORT_OWNER_ENTITY_TYPE_LABEL[user.type]}
              </FieldValue>
              <FieldValue flex={ownerEntityTableColumn[5].flex}>{user.profitShareRate * 100}%</FieldValue>
            </Row>
          ))
        ) : (
          <EmptyTable label="貸主を追加" message="貸主が見つかりません" handleClick={onClickAddOwnerEntity} />
        )}
      </Table>
      <Pagination totalPages={totalPages} pageIndex={pageIndex} setPageIndex={setPageIndex} />
    </>
  );
};

export default DataTable;
